import React from 'react';
import styled, { css } from 'styled-components';

import Media from 'css/Media';

let frMajor = null;
let frMinor = null;

export default props => {
    if(props.cols) {
        frMajor = (1800 / props.cols) - ((1800 / props.cols) * .435) + 'px';
        frMinor = ((1800 / props.cols) - ((1800 / props.cols) * .435)) * .435 + 'px';
    }

    return (
        <Container 
            flex={props.flex ? 1 : 0} 
            wrap={props.wrap ? 1 : 0} 
            direction={props.direction} 
            justify={props.justify} 
            align={props.align}
            grid={props.grid}
            cols={props.cols}
            rows={props.rows}
            mobileBleed={props.mobileBleed}
            bleed={props.bleed}
            bleedRight={props.bleedRight}
            fixed={props.fixed}
            className="container" 
            id={props.id}
        >
            {props.children}
        </Container>
    )
}


const Container = styled.div`
    width:100%;
    margin: 0 auto;
    position: relative;
    padding: ${props => (props.mobileBleed || props.bleed) ? '0' : props.bleedRight ? '0 0 0 25px' : '0 25px'};

    ${Media.greaterThan('s')`
        padding: ${props => props.bleedRight ? '0 0 0 45' : props.bleed ? '0' : '0 45'}px;
    `}

    ${Media.greaterThan('m')`
        padding: ${props => props.bleedRight ? '0 0 0 60' : props.bleed ? '0' : '0 60'}px;
    `}

    ${Media.greaterThan('l')`
        padding: ${props => props.bleedRight ? '0 0 0 80' : props.bleed ? '0' : '0 80'}px;
    `}

    ${Media.greaterThan('xl')`
        max-width: ${props => props.bleedRight ? 'none' : '1800px'};
        padding: 0;
        
        ${props => props.bleedRight && css`
            max-width: ${props => props.bleedRight ? 'none' : '1800px'};
            margin-left: calc((100vw - 1800px) / 2);
            margin-right: calc((100vw - 1800px) / 2);
            overflow-X: visible;
        `}
    `}

    ${props => props.fixed && css`
        position: fixed;
        top: 0;
        padding-top: ${props => props.theme.spacing.elementXS};
    `}

    ${props => props.flex ? `display: flex;` : ``}
    ${props => props.wrap ? `flex-wrap: wrap;` : ``}
    ${props => props.direction ? `flex-firection: ${props.direction};` : ``}
    ${props => props.justify ? `justify-content: ${props.justify};` : ``}
    ${props => props.align ? `align-items: ${props.align};` : ``}

    ${props => props.grid && css`
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: (1fr .359fr)[3] 1fr;
        grid-template-columns: repeat(3, 1fr .359fr) 1fr;
        -ms-grid-rows: ${props => props.rows || 'auto'};
        grid-template-rows: ${props => props.rows || 'auto'};
        
        /* ${Media.greaterThan('xs')`
            -ms-grid-columns: (1fr .13fr)[3] 1fr;
            grid-template-columns: repeat(3, 1fr .13fr) 1fr;
        `} */

        ${Media.greaterThan('s')`
            -ms-grid-columns: (1fr .67fr)[11] 1fr;
            grid-template-columns: repeat(11, 1fr .67fr) 1fr;
        `}

        ${Media.greaterThan('m')`
            -ms-grid-columns: (1fr .435fr)[11] 1fr;
            grid-template-columns: repeat(11, 1fr .435fr) 1fr;
        `}

        ${Media.greaterThan('l')`/* 
            -ms-grid-columns: (1fr .322fr)[11] 1fr;
            grid-template-columns: repeat(11, 1fr .322fr) 1fr; */
            ${props => props.cols && css`
                -ms-grid-columns: (${frMajor} ${frMinor})[${props.cols}] ${frMajor};
                grid-template-columns: repeat(${props.cols}, ${frMajor} ${frMinor}) ${frMajor};
            `}
        `}
    `}
`